import { globalRef, logDebug, onLine, requestWithRetry } from '@amazon/vinyl-util'
import { CacheManager } from '@amazon/vinyl-cache-manager'
import { ctx } from '@/util/context'

const { target } = ctx('dynamicCache')

// The retrying requester replays its input on every attempt, and a Request body can be read only once.
export async function requestFromNetwork(input: RequestInfo): Promise<Response> {
    const request = new Request(input)
    const { url, method, headers, credentials } = request
    const body = method === 'GET' || method === 'HEAD' ? null : await request.arrayBuffer()
    return requestWithRetry(url, { method, headers, credentials, body })
}

export const cacheManagerRef = globalRef(() => new CacheManager({ requestFromNetwork }))

export function getCacheManager(): CacheManager {
    return cacheManagerRef.value
}

/**
 * Removes old cache entries that have passed their TTL.
 */
export async function cleanCache() {
    if (onLine()) {
        logDebug(target, 'purging stale cache items')
        await getCacheManager().clean()
    }
}
